// extracted by mini-css-extract-plugin
export default {"wrapper":"introductionjackbox_wrapper__iIXuJ","button":"introductionjackbox_button__hwPoT"};